import CIMSLink from 'components/CIMSLink'
import { PayItemConnection } from '../../ConnectionsContext'
import Warning from '../../../../../Warning'

const Source: React.FC<PayItemConnection> = ({
  lastSyncError,
  googleSheet,
}) => {
  const source = googleSheet ?? { __typename: 'unknown' }
  return (
    <Warning visible={!!lastSyncError}>
      {source.__typename === 'GoogleSheetPayItemConnection' && (
        <CIMSLink external href={source.url}>
          {source.title ?? source.compositeId}
        </CIMSLink>
      )}
      {source.__typename === 'unknown' && <>Unknown</>}
    </Warning>
  )
}

export default Source
